import React, { useState, useRef } from "react";
import { useAtom } from "jotai";

import { forgotPasswordState } from "../../../states/forgotPasswordState";
import { loadingState } from "../../../states/loadingState";

import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useForm, Controller } from "react-hook-form";
import env from "@beam-australia/react-env";
import { InputText } from "primereact/inputtext";
import { classNames } from "primereact/utils";
import { Button } from "primereact/button";
import useApi from "../../../hooks/useApi";
import "./resetPassword.css";
import { Toast } from "primereact/toast";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleInfo } from "@fortawesome/free-solid-svg-icons";
import { useGoogleReCaptcha } from "react-google-recaptcha-v3";

const ResetPasswordStep1_initRecovery = ({ settings }) => {
  const { t } = useTranslation();
  const api = useApi();
  const [isLoading, setIsLoading] = useAtom(loadingState);
  const [captchaToken, setCaptchaToken] = useState(null);
  const navigate = useNavigate();
  const toast = useRef(null);

  const setForgotPassword = null; // = useAtom(forgotPasswordState);

  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm({
    defaultValues: {
      email: "",
      password: "",
    },
  });

  const { executeRecaptcha } = useGoogleReCaptcha();

  const onSubmit = async (data) => {
    if (!executeRecaptcha) {
      toast.current.show({
        severity: "error",
        summary: "Error",
        detail: "reCAPTCHA no disponible",
        life: 3000,
      });
      return;
    }

    const token = await executeRecaptcha("submit");

    if (!token) {
      toast.current.show({
        severity: "error",
        summary: "Error",
        detail: "Error al generar el reCAPTCHA",
        life: 3000,
      });
      return;
    }

    setCaptchaToken(token);
    setIsLoading(true);

    try {
      const response = await api.post(
        `${env("API_URL")}/base/auth/initrecovery`,
        { ...data, captchaToken: token }
      );

      toast.current.show({
        severity: "success",
        summary: t("forms.messages.titles.success"),
        detail: t("forms.messages.operation.success"),
        life: 3000,
      });

      setForgotPassword((prevState) => ({
        ...prevState,
        email: data.email,
      }));

      navigate("/ResetPasswordStep2_checkRecovery");
    } catch (error) {
      toast.current.show({
        severity: "error",
        summary: t("forms.messages.titles.error"),
        detail: t("forms.messages.operation.error"),
        life: 3000,
      });

      setIsLoading(false);
    }
  };

  const getFormErrorMessage = (error) => {
    return error && <small className="p-error">{error.message}</small>;
  };

  return (
    <React.Fragment>
      <Toast ref={toast} />
      <div className="flex justify-content-center align-items-center h-screen">
        <div className="flex flex-column  justify-content-center align-items-center p-4 border-1 border-400">
          <div>
            <p className="inputHelpText inputHelpText_small p-4">
              Ingresa tu dirección de correo electrónico a dónde te enviaremos
              un código de seis dígitos para modificar tu contraseña.
            </p>
          </div>
          <form onSubmit={handleSubmit(onSubmit)} className="p-fluid">
            <div className="field">
              <Controller
                name="email"
                control={control}
                rules={{
                  required: t("forms.validation.required", {
                    entity: t("entities.beneficiaries.email"),
                  }),
                  maxLength: {
                    value: 30,
                    message: t("forms.validation.maxLength", {
                      entity: t("entities.beneficiaries.email"),
                      maxLength: 30,
                    }),
                  },
                }}
                render={({ field, fieldState }) => (
                  <React.Fragment>
                    <div className="flex justify-content-between">
                      <label htmlFor="email">
                        {t("entities.beneficiaries.email")}
                      </label>
                      <div>{getFormErrorMessage(errors.email)}</div>
                    </div>
                    <div className="form-crud">
                      <div className="p-inputgroup">
                        <span className="p-inputgroup-addon">
                          <i className="pi pi-user"></i>
                        </span>
                        <span className="p-float-label">
                          <InputText
                            id="email"
                            {...field}
                            value={field.value || ""}
                            maxLength={30}
                            className={[
                              "form-control",
                              classNames({
                                "p-invalid": fieldState.invalid,
                              }),
                            ]}
                          />
                        </span>
                      </div>
                    </div>
                  </React.Fragment>
                )}
              />
              <span className="inputHelpText inputHelpText_small">
                <FontAwesomeIcon
                  icon={faCircleInfo}
                  style={{ paddingRight: "5px", paddingTop: "5px" }}
                />
                Ingresá tu dirección de correo electrónico.
              </span>
            </div>

            <Button
              label={t("send_code")}
              className="button_big"
              loading={isLoading}
            />

            <p
              className="inputHelpText inputHelpText_small"
              style={{ textAlign: "center", paddingTop: "20px" }}
            >
              Textum es un servicio exclusivo para el personal de nuestras
              empresas asociadas.
            </p>
          </form>
        </div>
      </div>
    </React.Fragment>
  );
};

export default ResetPasswordStep1_initRecovery;
